import { createAction } from "@reduxjs/toolkit"
import { Flags } from "./flags"

export const setFlagsAction = createAction<Flags>("SET_FLAGS")
